import { PRICING_PLANS } from "features/subscriptions/constants";
import { formatPricingPeriodInfo } from "features/subscriptions/utils";

import type {
  AgencyPlan,
  DetailedWorkspace,
  Pricing,
  SubscriptionStatus,
  SubscriptionType,
} from "common/types";

const PLAN_LABEL_SUBSCRIPTION_STATUSES: SubscriptionStatus[] = [
  "active",
  "in_trial",
  "non_renewing",
];

function formatPlanLine(
  type: SubscriptionType,
  status: SubscriptionStatus,
  item_price: Pricing,
): string {
  const name = PRICING_PLANS[type].name;
  const period = formatPricingPeriodInfo(item_price);
  return `${name} · ${status} · ${period}`;
}

export function getIntercomPlanTypeLabel(
  workspace: DetailedWorkspace,
  agencyPlan: AgencyPlan | undefined,
): string {
  const accountParts: string[] = [];
  const workspaceParts: string[] = [];

  const agencySub = agencyPlan?.subscription;
  if (
    agencySub &&
    PLAN_LABEL_SUBSCRIPTION_STATUSES.includes(agencySub.status)
  ) {
    const { type, status, item_price } = agencySub;
    accountParts.push(formatPlanLine(type, status, item_price));
  }

  const userSub = workspace.subscription;
  if (userSub && PLAN_LABEL_SUBSCRIPTION_STATUSES.includes(userSub.status)) {
    const { type, status, item_price } = userSub;
    workspaceParts.push(formatPlanLine(type, status, item_price));
  }

  workspace.rental_subscriptions?.forEach((rental) => {
    if (rental.status === "active" || rental.status === "non_renewing") {
      const { type, status, item_price } = rental;
      workspaceParts.push(formatPlanLine(type, status, item_price));
    }
  });

  const segments: string[] = [];
  if (accountParts.length > 0) {
    segments.push(`Account: ${accountParts.join(" │ ")}`);
  }
  if (workspaceParts.length > 0) {
    segments.push(`Workspace: ${workspaceParts.join(" │ ")}`);
  }
  if (segments.length > 0) {
    return segments.join("; ");
  }

  if (workspace.lifetime_license_count > 0) {
    return "Workspace: Lifetime / promotional";
  }

  return "No active subscription";
}
